import { UntypedFormGroup, FormControl } from '@angular/forms';
import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Authenticationservice } from '../../services/authentication.service';
import Stepper from 'bs-stepper';
import axios from 'axios';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-resulttsupportter',
  templateUrl: './resulttsupportter.component.html',
  styleUrls: ['./resulttsupportter.component.css']
})
export class ResulttsupportterComponent implements OnInit , OnDestroy{
userdata:any;
private stepper: Stepper;
  constructor(private spinner: NgxSpinnerService,private auth:Authenticationservice) { 
    this.userdata = this.auth.Authention();
  }
  selecttime = [
    { time: 'ประจำงวดที่ 2 มี.ค. 2565', set: '2022-03-02' },
    { time: 'ประจำงวดที่ 1 เม.ย. 2565', set: '2022-04-01' },
    { time: 'ประจำงวดที่ 2 เม.ย. 2565', set: '2022-04-02' },
    { time: 'ประจำงวดที่ 1 พ.ค. 2565', set: '2022-05-01' },
    { time: 'ประจำงวดที่ 2 พ.ค. 2565', set: '2022-05-02' },
  ];

  timework:any;
  defaltsets:any = [];
  topic1:any = []; 
  topic2:any = []; 
  topic3:any = []; 
  topic4:any = []; 
  Action:UntypedFormGroup;
  ngOnInit(): void {
  
    if (this.allkpidata != null){}
    else { this.Loadkpiall();}

    
  }

  ngOnDestroy(): void {
    this.allkpidata = null;
    this.supporttercode = null;
    this.supportterlist = null;
    this.areacode = null;
    this.arealist = null;
    this.partcode = null;
    this.partlist = null;
    
  }

  @ViewChild('table') table: ElementRef;
  ExportExcel()
  {
  const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(this.table.nativeElement);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  /* save to file */
  XLSX.writeFile(wb, 'ข้อมูล KPI'+this.userdata.supcode+'.xlsx');
  }


  allkpidata:any;
  supporttercode:any;
  supportterlist:any;
  areacode:any;
  arealist:any;
  partcode:any;
  partlist:any;
  mysup:any;
  Loadkpiall(){
    this.spinner.show();
    axios.get('https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_kpi_6501_w?1=1').then(res => {
     this.allkpidata =  res.data.recordset;
     this.supportterlist = this.allkpidata.filter(el=> el.supcode != 'sum')
     this.supportterlist.sort(function(a, b){return a.supcode - b.supcode});
     this.arealist = this.allkpidata.filter(el=> el.supcode == 'sum' && el.supzone != 'sum')
     this.partlist = this.allkpidata.filter(el=> el.supcode == 'sum' && el.supzone == 'sum')
    this.mysup =  this.allkpidata.filter(el=> el.supcode != 'sum' && el.supzone.trim() == this.userdata.zonedata);
    this.spinner.hide();
      }).catch(err => { this.spinner.hide();
      throw(err)
    });
       this.spinner.hide();
  }

  bydate:any;
  date:any;
  Loadbydate(){
    this.spinner.show();
    axios.get('https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_fnc_brdlotwork_6501_w?Lotdate='+this.date[0]).then(res => {
      if (res.data.rowsAffected[0]==0){
        alert('ไม่มีข้อมูล');
      }
      else {
      this.bydate =  res.data.recordset;
      console.log(this.bydate.filter(el => el.Partcode === 'BRD'));
      }
     this.spinner.hide();
       }).catch(err => { this.spinner.hide();
       throw(err)
     });
    this.spinner.hide();
  }

  supname:any;
  texttitle:any;
  mainbarrier:any;
  DatafilterBysupcode(id:any){
   
    this.topic1 = [];
    this.topic2 = [];
    this.topic3 = [];
    this.topic4 = [];

    let supdata:any;
    let byd:any;
    this.spinner.show();
    if (this.bydate == null){

    }
    else if(id == 1){
      this.texttitle = "ผลลัพธ์ของพนักงานส่งเสริมที่บริษัทต้องการ 65/66"
      supdata = this.allkpidata.filter((el:any) =>  el.supcode == this.supporttercode);
      this.supname = supdata[0].supcode +' '+supdata[0].supname 
      byd = this.bydate.filter((el:any) =>  el.Supcode == this.supporttercode);
    }
    else if(id == 2){
      this.texttitle = "ผลลัพธ์ของหัวหน้าเขตส่งเสริมส่งเสริมที่บริษัทต้องการ 65/66"
      supdata = this.arealist.filter((el:any) =>  el.supzone == this.areacode);
      byd = this.bydate.filter((el:any) =>  el.Supzone == this.areacode && el.Supcode == 'sum');
      this.supname = '';
    }
    else if(id == 3){
      this.texttitle = "ผลลัพธ์ของผู้จัดการส่วนส่งเสริมที่บริษัทต้องการ 65/66"
      supdata = this.partlist.filter((el:any) =>  el.Partcode == this.partcode);
      byd = this.bydate.filter((el:any) =>  el.Partcode == this.partcode && el.Supzone == 'sum' && el.Supcode == 'sum');
      this.supname = '';
    }

    this.mainbarrier = [{ 'topic1':byd[0].Barrier21 ,'topic2':byd[0].Barrier22,'topic3':byd[0].Barrier23,'topic4':byd[0].Barrier24}];
    this.timework ='งวด ' + byd[0].Lotdate_name;
    this.defaltsets = [
      {id:'', topic:'ปริมาณอ้อยรวม',quality:'คำนวณจากระบบ', count:supdata[0].targrt_Assess ,collect:supdata[0].Assess_b , perone:'ตัน',persen:supdata[0].pc_targrt_Assess_b},
      {id:'', topic:'ปริมาณอ้อยรวม',quality:'ข้อมูลในระบบ', count:supdata[0].targrt_Assess ,collect:supdata[0].Assess , perone:'ตัน',persen:supdata[0].pc_targrt_Assess},
      {id:'', topic:'ผลผลิตอ้อยปลายฝน',quality:'', count:supdata[0].yield_target_ER,collect:supdata[0].yield_er, perone:'ตัน/ไร่',persen:supdata[0].pc_yield_er},
      {id:'', topic:'ผลผลิตอ้อยตอ',quality:'', count:supdata[0].yield_target_ST,collect:supdata[0].yield_st, perone:'ตัน/ไร่',persen:supdata[0].pc_yield_st},
      {id:'', topic:'ผลผลิตอ้อยต้นฝน',quality:'', count:supdata[0].yield_target_SR,collect:supdata[0].yield_sr, perone:'ตัน/ไร่',persen:supdata[0].pc_yield_sr},
      ];
      this.topic1 = [
        {id:'', topic:'พื้นที่รวม',     quality:'', count:supdata[0].sum_areas ,collect:supdata[0].landvalue  , perone:'ไร่',persen:supdata[0].pc_areas 
        ,tg1:'',sc1:'',pc_tg1:'',brr1:'',score1:'' } ,
        {id:'1.1', topic:'พื้นที่ปลายฝน',  quality:'วัดที่ 100% สะสม', count:supdata[0].target_ER, collect:supdata[0].areas_er , perone:'ไร่',persen:supdata[0].pc_areas_er
        ,tg1:byd[0].Target1 ,sc1:byd[0].Success1 ,pc_tg1:byd[0].pc_target1 ,brr1:byd[0].Barrier11 ,score1:byd[0].score1 },
        {id:'1.2', topic:'อ้อยตอ', quality:'วัดที่ 65% สะสม', count:supdata[0].target_ST, collect:supdata[0].areasY_st , perone:'ไร่',persen:supdata[0].pc_areas_yst 
        ,tg1:byd[0].Target2 ,sc1:byd[0].Success2 ,pc_tg1:byd[0].pc_target2 ,brr1:byd[0].Barrier12 ,score1:byd[0].score2 },
        {id:'1.3', topic:'อ้อยต้นฝน',    quality:'', count:supdata[0].target_SR, collect:supdata[0].areas_sr , perone:'ไร่', persen:supdata[0].pc_areas_sr
        ,tg1:byd[0].Target3 ,sc1:byd[0].Success3 ,pc_tg1:byd[0].pc_target3 ,brr1:byd[0].Barrier13 ,score1:byd[0].score3 },

        {id:'', topic:'',    quality:'', count:'', collect:'' , perone:'+++รวม', persen:''
        ,tg1:'' ,sc1:byd[0].scoresum1 ,pc_tg1:'' ,brr1:byd[0].sumbarrier1 ,score1:byd[0].score1get },

      ];
      this.topic2 = [
      {id:'2.1', topic:'การระเบิดดาน',quality:'คุณภาพของกิจกรรม', count:supdata[0].tg_landvalue_New_Y ,collect:supdata[0].hardSoilBlast , perone:'ไร่',persen:supdata[0].pc_hardSoilBlast
      ,tg1:byd[0].Target4 ,sc1:byd[0].Success4 ,pc_tg1:byd[0].pc_target4 ,brr1:byd[0].Barrier14 ,score1:byd[0].score4 },

      {id:'2.2', topic:'พันธุ์อ้อย',quality:'คุณภาพของกิจกรรมล็อคแปลงพันธุ์ส่วนตัว (กี่แถว กี่งาน)', count:'' ,collect:'', perone:'ไร่',persen:''
      ,tg1:byd[0].Target5 ,sc1:byd[0].Success5 ,pc_tg1:byd[0].pc_target5 ,brr1:byd[0].Barrier15 ,score1:byd[0].score5},

      {id:'2.3', topic:'ระยะร่อง',quality:'คุณภาพของกิจกรรมอ้อยที่จะปลูกใหม่ต้นฝน10365 ระยะร่อง 1.6-1.7 เมตร', count:supdata[0].landvalue_SR_Y ,collect:supdata[0].Groove, perone:'ไร่',persen:supdata[0].pc_Groove
      ,tg1:byd[0].Target6 ,sc1:byd[0].Success6 ,pc_tg1:byd[0].pc_target6 ,brr1:byd[0].Barrier16 ,score1:byd[0].score6},

      {id:'2.4', topic:'ปุ๋ยเคมี 1',quality:'คุณภาพของกิจกรรม1-14วัน', count:supdata[0].landvalue ,collect:supdata[0].FertilizerRound1, perone:'ไร่',persen:supdata[0].pc_FertilizerRound1
      ,tg1:byd[0].Target7 ,sc1:byd[0].Success7 ,pc_tg1:byd[0].pc_target7 ,brr1:byd[0].Barrier17 ,score1:byd[0].score7},
      {id:'2.5', topic:'ปุ๋ยเคมี 2',quality:'ที่อ้อยอายุตั้งแต่ 45-60 วัน(อ้อยแตกกอชุดที่ 2 )', count:supdata[0].landvalue ,collect:supdata[0].FertilizerRound2 , perone:'ไร่',persen:supdata[0].pc_FertilizerRound2 
      ,tg1:byd[0].Target8 ,sc1:byd[0].Success8 ,pc_tg1:byd[0].pc_target8 ,brr1:byd[0].Barrier18 ,score1:byd[0].score8},
      {id:'2.6', topic:'ปุ๋ยเคมี 3',quality:'ใส่เมื่ออายุอ้อย 90-100 วัน ผลผลิต 15 ตันขึ้นไปปลายฝน', count:supdata[0].area_ton15 ,collect:supdata[0].FertilizerRound3, perone:'ไร่',persen:supdata[0].pc_FertilizerRound3
      ,tg1:byd[0].Target9 ,sc1:byd[0].Success9 ,pc_tg1:byd[0].pc_target9 ,brr1:byd[0].Barrier19 ,score1:byd[0].score9},
      {id:'2.7', topic:'การใส่อินทรีย์',quality:'คุณภาพของกิจกรรม มากกว่า500kg/ไร่แปลงปลูกใหม่ทุกแปลงปลายฝน', count:supdata[0].tg_landvalue_New_Y ,collect:supdata[0].NaturalFerti, perone:'ไร่',persen:supdata[0].pcNaturalFerti
      ,tg1:byd[0].Target10 ,sc1:byd[0].Success10 ,pc_tg1:byd[0].pc_target10 ,brr1:byd[0].Barrier110 ,score1:byd[0].score10},
      {id:'2.8', topic:'การใส่โดโลไมท์',quality:'คุณภาพของกิจกรรมมากว่า50 kg/ไร่ ทุกแปลง', count:supdata[0].landvalue ,collect:supdata[0].AmountDolomite, perone:'ไร่',persen:supdata[0].pc_AmountDolomite
      ,tg1:byd[0].Target11 ,sc1:byd[0].Success11 ,pc_tg1:byd[0].pc_target11 ,brr1:byd[0].Barrier111 ,score1:byd[0].score11},

      {id:'2.9', topic:'เปอร์เซนต์การงอก',quality:'คุณภาพของกิจกรรม ซ่อมอ้อยเต็มแปลง ที่อายุ30-45 วัน (งอกต่ำกว่า90 ควรซ่อม)', count:supdata[0].landvalue ,collect:supdata[0].GerminationPercent , perone:'ไร่',persen:supdata[0].pc_GerminationPercent
      ,tg1:byd[0].Target12 ,sc1:byd[0].Success12 ,pc_tg1:byd[0].pc_target12 ,brr1:byd[0].Barrier112 ,score1:byd[0].score12},

      {id:'2.10', topic:'วัชพืช',quality:'ต้องไม่มีวัชพืชรบกวน', count:supdata[0].landvalue ,collect:supdata[0].lastweet, perone:'ไร่',persen:supdata[0].pc_lastweet
      ,tg1:byd[0].Target13 ,sc1:byd[0].Success13 ,pc_tg1:byd[0].pc_target13 ,brr1:byd[0].Barrier113 ,score1:byd[0].score13},

      {id:'2.11', topic:'โรคและแมลง',quality:'ตรวจโรคและแมลงทุกแปลง %ระบาด', count:supdata[0].landvalue ,collect:supdata[0].Disease, perone:'ไร่',persen:supdata[0].pc_Disease
      ,tg1:byd[0].Target14 ,sc1:byd[0].Success14 ,pc_tg1:byd[0].pc_target14 ,brr1:byd[0].Barrier114 ,score1:byd[0].score14},
      {id:'2.12', topic:'การพูนโคน',quality:'การพูนโคนในอ้อยปลูกใหม่เพื่อลดการสูญเสียจากการตัดอ้อย', count:supdata[0].landvalue ,collect:'', perone:'ไร่',persen:''
      ,tg1:byd[0].Target15 ,sc1:byd[0].Success15 ,pc_tg1:byd[0].pc_target15 ,brr1:byd[0].Barrier115 ,score1:byd[0].score15},

      {id:'', topic:'',    quality:'', count:'', collect:'' , perone:'+++รวม', persen:''
        ,tg1:'' ,sc1:byd[0].scoresum2 ,pc_tg1:'' ,brr1:byd[0].sumbarrier2 ,score1:byd[0].score2get },
      ]
      this.topic3 = [
        {id:'3.1', topic:byd[0].label1, quality:'-', count:'' ,collect:''  , perone:'-',persen:'',tg1:byd[0].Target31 ,sc1:byd[0].Success31 ,pc_tg1:byd[0].pc_target31 ,brr1:byd[0].Barrier131 ,score1:byd[0].score31 },
        {id:'3.2', topic:byd[0].label2,   quality:'', count:'', collect:'' , perone:'',persen:'',tg1:byd[0].Target32 ,sc1:byd[0].Success32 ,pc_tg1:byd[0].pc_target32 ,brr1:byd[0].Barrier132 ,score1:byd[0].score32 },
        {id:'3.3', topic:byd[0].label3,   quality:'', count:'', collect:'' , perone:'',persen:'',tg1:byd[0].Target33 ,sc1:byd[0].Success33 ,pc_tg1:byd[0].pc_target33 ,brr1:byd[0].Barrier133 ,score1:byd[0].score33 },
        {id:'3.4', topic:byd[0].label4,    quality:'', count:'', collect:'' , perone:'', persen:'',tg1:byd[0].Target34 ,sc1:byd[0].Success34 ,pc_tg1:byd[0].pc_target34 ,brr1:byd[0].Barrier134 ,score1:byd[0].score34 },
        {id:'3.5', topic:byd[0].label5,   quality:'', count:'', collect:'' , perone:'',persen:'',tg1:byd[0].Target35 ,sc1:byd[0].Success35 ,pc_tg1:byd[0].pc_target35 ,brr1:byd[0].Barrier135 ,score1:byd[0].score35 },
        {id:'3.6', topic:byd[0].label6,   quality:'', count:'', collect:'' , perone:'',persen:'',tg1:byd[0].Target36 ,sc1:byd[0].Success36 ,pc_tg1:byd[0].pc_target36 ,brr1:byd[0].Barrier136 ,score1:byd[0].score36 },
        {id:'3.7', topic:byd[0].label7,    quality:'', count:'', collect:'' , perone:'', persen:'',tg1:byd[0].Target37 ,sc1:byd[0].Success37 ,pc_tg1:byd[0].pc_target37 ,brr1:byd[0].Barrier137 ,score1:byd[0].score37 },
        {id:'3.8', topic:byd[0].label8,   quality:'', count:'', collect:'' , perone:'',persen:'',tg1:byd[0].Target38 ,sc1:byd[0].Success38 ,pc_tg1:byd[0].pc_target38 ,brr1:byd[0].Barrier138 ,score1:byd[0].score38 },
        {id:'3.9', topic:byd[0].label9,   quality:'', count:'', collect:'' , perone:'',persen:'',tg1:byd[0].Target39 ,sc1:byd[0].Success39 ,pc_tg1:byd[0].pc_target39 ,brr1:byd[0].Barrier139 ,score1:byd[0].score39 },
        {id:'3.10', topic:byd[0].label10,    quality:'', count:'', collect:'' , perone:'', persen:'',tg1:byd[0].Target40 ,sc1:byd[0].Success40 ,pc_tg1:byd[0].pc_target40 ,brr1:byd[0].Barrier140 ,score1:byd[0].score40 },
        {id:'', topic:'',    quality:'', count:'', collect:'' , perone:'+++รวม', persen:''
        ,tg1:'' ,sc1:byd[0].scoresum3 ,pc_tg1:'' ,brr1:byd[0].sumbarrier3 ,score1:byd[0].score3get },
      ];
      this.topic4 = [
        {id:'4.1', topic:' เกรดชาวไร่',quality:'', count:supdata[0].cnt_fm ,collect:''  , perone:'ราย',persen:''},
        {id:'', topic:'- เกรด A',   quality:'', count:'', collect:supdata[0].score_A , perone:'ราย',persen:supdata[0].pc_score_A
        ,tg1:byd[0].Target16 ,sc1:byd[0].Success16 ,pc_tg1:byd[0].pc_target16 ,brr1:byd[0].Barrier116 ,score1:byd[0].score16 },
        {id:'', topic:'- เกรด B',   quality:'', count:'', collect:supdata[0].score_B , perone:'ราย',persen:supdata[0].pc_score_B
        ,tg1:byd[0].Target17 ,sc1:byd[0].Success17 ,pc_tg1:byd[0].pc_target17 ,brr1:byd[0].Barrier117 ,score1:byd[0].score17 },
        {id:'', topic:'- เกรด C',    quality:'', count:'', collect:supdata[0].score_C , perone:'ราย', persen:supdata[0].pc_score_C
        ,tg1:byd[0].Target18 ,sc1:byd[0].Success18 ,pc_tg1:byd[0].pc_target18 ,brr1:byd[0].Barrier118 ,score1:byd[0].score18 },
        {id:'4.2', topic:'การตรวจเยี่ยมชาวไร่',    quality:'', count:'', collect:supdata[0].score_C , perone:'ราย', persen:supdata[0].pc_score_C
        ,tg1:byd[0].Target19 ,sc1:byd[0].Success19 ,pc_tg1:byd[0].pc_target19 ,brr1:byd[0].Barrier119 ,score1:byd[0].score19 },

        {id:'4.3', topic:' สินเชื่อ',quality:'', count:supdata[0].cnt_fm ,collect:''  , perone:'',persen:''},
        {id:'4.3.1', topic:'อ้อยปลูกใหม่แปลงที่จ่ายเกี้ยว 4-6 พันบาท',   quality:'', count:supdata[0].tg_landvalue_New_Y, collect:supdata[0].landvalue_new , perone:'ไร่',persen:supdata[0].pclandvalue_new
        ,tg1:byd[0].Target20 ,sc1:byd[0].Success20 ,pc_tg1:byd[0].pc_target20 ,brr1:byd[0].Barrier120 ,score1:byd[0].score20 },

        {id:'4.3.2', topic:'แปลงที่จ่าย 6,000 บาท แต่ยังไม่ปลูก',   quality:'', count:supdata[0].tg_landvalue_new, collect:supdata[0].landvalue_P , perone:'ไร่',persen:supdata[0].pclandvalue_P
        ,tg1:byd[0].Target21 ,sc1:byd[0].Success21 ,pc_tg1:byd[0].pc_target21 ,brr1:byd[0].Barrier121 ,score1:byd[0].score21 },
        {id:'4.3.3', topic:'แปลงที่จ่าย 6,000 บาท ทำกิจกรรมครบตามแผน(ระเบิดาน, อินทรีย์,โดโลไมท์)',    quality:'', count:supdata[0].tg_landvalue_new, collect:supdata[0].landvalue_Pa , perone:'ไร่', persen:supdata[0].pclandvalue_Pa
        ,tg1:byd[0].Target22 ,sc1:byd[0].Success22 ,pc_tg1:byd[0].pc_target22 ,brr1:byd[0].Barrier122 ,score1:byd[0].score22 },

        
        {id:'', topic:'',    quality:'', count:'', collect:'' , perone:'+++รวม', persen:''
        ,tg1:'' ,sc1:byd[0].scoresum4 ,pc_tg1:'' ,brr1:byd[0].sumbarrier4 ,score1:byd[0].score4get },

        {id:'', topic:'',    quality:'', count:'', collect:'' , perone:'+++รวมคะแนน', persen:''
        ,tg1:'' ,sc1:'' ,pc_tg1:'' ,brr1:'' ,score1:byd[0].scoretotal },
      ];

      this.spinner.hide();
  }

  goPrint(){
    window.print();
  }
}
